import React, { useState, useEffect, useRef } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { Loader } from '@googlemaps/js-api-loader';
import { ClipLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

const LocationSearchTextBox = ({ date, countryCode, onLocationChnage, error }) => {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState([]);
    const autocompleteService = useRef(null);
    const autocompleteRef = useRef(null);
    const debounceTimeout = useRef(null);
    const [loading, setLoading] = useState(false);
    const [location, setLocation] = useState()
    const [locationGeoData, setLocationGeoData] = useState()
    const [locationTimeZone, setLocationTimeZone] = useState()

    const loader = new Loader({
        apiKey: 'AIzaSyCm7veyYMw6eUckCRwj_zCwXofY1_H-mRk',
        version: 'weekly',
        libraries: ['places'],
    });

    useEffect(() => {

        loader.load().then(() => {
            autocompleteService.current = new window.google.maps.places.AutocompleteService();
        });
    }, []);

    const fetchSuggestions = (input) => {
        if (autocompleteService.current && input) {
            setLoading(true);
            autocompleteService.current.getPlacePredictions({
                input,
                componentRestrictions: { country: countryCode }, // Restrict to Sri Lanka
                types: ['locality', 'hospital'], // Restrict to cities and hospitals
                language: 'si', // Set language to Sinhala
            }, (predictions) => {
                setLoading(false);
                const formattedOptions = (predictions || []).map((prediction) => ({
                    label: prediction.description,
                    place_id: prediction.place_id,
                }));
                setOptions(formattedOptions);
            });
        }
    };

    const fetchTimeZone = (placeId, locationValue) => {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ placeId }, (results, status) => {
            if (status === 'OK' && results[0]) {
                const locationLonLng = results[0].geometry.location;
                console.log("results[0].geometry", locationLonLng.lat());
                const locationGeoDataTemp = {lat : locationLonLng.lat(), lng : locationLonLng.lng()}
                setLocationGeoData(locationGeoDataTemp);
                const timestamp = new Date(date).getTime() / 1000;
                fetch(`https://maps.googleapis.com/maps/api/timezone/json?location=${locationLonLng.lat()},${locationLonLng.lng()}&timestamp=${timestamp}&key=${loader.apiKey}`)
                    .then(response => response.json())
                    .then(data => {
                        console.log('Time Zone Data:', data);
                        const locationTimeZoneTemp = data;
                        setLocationTimeZone(locationTimeZoneTemp);
                        let locData = {
                            location : locationValue,
                            locationGeoData : locationGeoDataTemp,
                            locationTimeZone : locationTimeZoneTemp
                        };
                        console.log("locData", locData)
                        onLocationChnage(
                            locData
                        )
                    })
                    .catch(error => {
                        console.error('Error fetching time zone data:', error);
                    });
            }
        });
    };

    const handleInputChange = (event, newInputValue) => {
        console.log("handleInputChange", newInputValue)
        setInputValue(newInputValue);
        setLoading(newInputValue.length > 3);
        clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
            fetchSuggestions(newInputValue);
        }, 3000);
    };

    const handleOptionSelect = (event, value) => {
        if(value){
            console.log("handleOptionSelect location chnage", value)
            setLocation(value)
            fetchTimeZone(value.place_id, value);
            
        }   
    };

    return (
        <Autocomplete
            freeSolo={false}
            options={options}
            onInputChange={handleInputChange}
            onChange={handleOptionSelect}
            noOptionsText={t("ENTER_LOCATION")} 
            renderInput={(params) => <TextField error={error}
                {...params}
                variant="outlined"
                fullWidth
                InputProps={{
                    ...params.InputProps,
                    style: { fontWeight: 'bold' }, // Apply bold style
                    endAdornment: (
                        <>
                            {loading ? (
                                <ClipLoader size={18} color="#000" />
                            ) : (
                                params.InputProps.endAdornment
                            )}
                        </>
                    ),
                }}
            />}
        />
    );
};

// Typechecking props for the MiniInfoCard
LocationSearchTextBox.propTypes = {
    date: PropTypes.string,
    countryCode: PropTypes.string,
    onLocationChnage: PropTypes.func,
    error: PropTypes.bool
};

export default LocationSearchTextBox;